import { Link } from 'react-router';
import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;

	@media (max-width: 992px) {
		flex-direction: column-reverse;
	}
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	max-width: 612px;
	width: 100%;

	@media (max-width: 992px) {
		max-width: 100%;
		text-align: center;
	}
`;

export const Title = styled.div`
	font-size: 48px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.text.title};

	@media (max-width: 992px) {
		font-size: 32px;
	}
`;

export const Description = styled.p`
	font-size: 20px;
	font-weight: 400;
	color: ${({ theme }) => theme.colors.text.subtitle};
	margin: 20px 0;
	line-height: 32px;

	@media (max-width: 992px) {
		font-size: 16px;
	}
`;

export const LinkStyled = styled(Link)`
	display: inline-flex;
	align-items: center;

	@media (max-width: 992px) {
		margin: 0 auto;
	}
`;

export const ImageWrapper = styled.div`
	display: flex;
	max-width: 578px;
	width: 100%;

	img {
		width: 100%;
		mix-blend-mode: lighten;
	}
`;
